export const TEMPLATE_SCENARIO_FETCH_REQUEST = 'TEMPLATE_SCENARIO_FETCH_REQUEST';
export const TEMPLATE_SCENARIO_FETCH_SUCCESS = 'TEMPLATE_SCENARIO_FETCH_SUCCESS';
export const TEMPLATE_SCENARIO_FETCH_FAILURE = 'TEMPLATE_SCENARIO_FETCH_FAILURE';
export const SCENARIOS_FETCH_REQUEST = 'SCENARIOS_FETCH_REQUEST';
export const SCENARIOS_FETCH_SUCCESS = 'SCENARIOS_FETCH_SUCCESS';
export const SCENARIOS_FETCH_FAILURE = 'SCENARIOS_FETCH_FAILURE';
export const SCENARIOS_INGEST_COMPLETE = 'SCENARIOS_INGEST_COMPLETE';
export const OUT_OF_BAND_BANNER_DISPLAYED = 'OUT_OF_BAND_BANNER_DISPLAYED';
export const OUT_OF_BAND_BANNER_HIDDEN = 'OUT_OF_BAND_BANNER_HIDDEN';
export const UPDATE_ACTIVE_COMPARISON = 'UPDATE_ACTIVE_COMPARISON';
export const COPY_DEAL_SCENARIO_CLICKED = 'COPY_DEAL_SCENARIO_CLICKED';
export const DELETE_DEAL_SCENARIO_CLICKED = 'DELETE_DEAL_SCENARIO_CLICKED';
export const SELECT_PRIMARY_DEAL_SCENARIO_CLICKED = 'SELECT_PRIMARY_DEAL_SCENARIO_CLICKED';
